/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetGetProductImagesUrlQueryResponse, GetGetProductImagesUrlPathParams, GetGetProductImagesUrlQueryParams, GetGetProductImagesUrl400, GetGetProductImagesUrl404 } from "../../models/GetGetProductImagesUrl";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetGetProductImagesUrlUrl({ code }: { code: GetGetProductImagesUrlPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/product-images-url` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/product-images-url}
 */
export async function getGetProductImagesUrl({ code, params }: { code: GetGetProductImagesUrlPathParams["code"]; params: GetGetProductImagesUrlQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetGetProductImagesUrlQueryResponse, ResponseErrorConfig<GetGetProductImagesUrl400 | GetGetProductImagesUrl404>, unknown>({ method : "GET", url : getGetGetProductImagesUrlUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}